import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lotoListing: { loading: false, data: [], error: null },
  lotoDetail: { loading: false, data: null, error: null },
  lotoAudit: { loading: false, data: [], error: null },
};

const lotoSlice = createSlice({
  name: "afmsLoto",
  initialState,
  reducers: {
    lotoListingStart: (state) => { state.lotoListing.loading = true; state.lotoListing.error = null; },
    lotoListingSuccess: (state, action) => { state.lotoListing.loading = false; state.lotoListing.data = action.payload; },
    lotoListingFailure: (state, action) => { state.lotoListing.loading = false; state.lotoListing.error = action.payload; },

    lotoDetailStart: (state) => { state.lotoDetail.loading = true; state.lotoDetail.error = null; },
    lotoDetailSuccess: (state, action) => { state.lotoDetail.loading = false; state.lotoDetail.data = action.payload; },
    lotoDetailFailure: (state, action) => { state.lotoDetail.loading = false; state.lotoDetail.error = action.payload; },

    lotoAuditStart: (state) => { state.lotoAudit.loading = true; state.lotoAudit.error = null; },
    lotoAuditSuccess: (state, action) => { state.lotoAudit.loading = false; state.lotoAudit.data = action.payload; },
    lotoAuditFailure: (state, action) => { state.lotoAudit.loading = false; state.lotoAudit.error = action.payload; },
  },
});

export const {
  lotoListingStart, lotoListingSuccess, lotoListingFailure,
  lotoDetailStart, lotoDetailSuccess, lotoDetailFailure,
  lotoAuditStart, lotoAuditSuccess, lotoAuditFailure,
} = lotoSlice.actions;

export default lotoSlice.reducer;
